let counter = 0;
const scriptMap = new Map();
export const ScriptCache = (function (global) {
    return function ScriptCache(scripts) {
        const Cache = {};
        Cache._onLoad = (key) => {
            return (cb) => {
                const stored = scriptMap.get(key);
                if (stored) {
                    stored.promise.then(() => {
                        stored.error ? cb(stored.error) : cb(null, stored);
                    });
                }
            };
        };
        Cache._scriptTag = (key, keySrc) => {
            let src = keySrc.initialize;
            const tagType = keySrc.tagType;
            if (!scriptMap.has(key)) {
                const tag = document.createElement("script");
                const promise = new Promise((resolve, reject) => {
                    const body = document.getElementsByTagName("body")[0];
                    tag.type = "text/javascript";
                    tag.async = true;
                    tag.defer = true;
                    const cbName = `loaderCB${counter++}${Date.now()}`;
                    const cleanup = () => {
                        if (global[cbName] && typeof global[cbName] === "function") {
                            global[cbName] = null;
                        }
                    };
                    const handleResult = (state) => {
                        return (evt) => {
                            const stored = scriptMap.get(key);
                            if (state === "loaded") {
                                stored.resolved = true;
                                resolve(src);
                            }
                            else if (state === "error") {
                                stored.errored = true;
                                reject(evt);
                            }
                            cleanup();
                        };
                    };
                    tag.onload = handleResult("loaded");
                    tag.onerror = handleResult("error");
                    if (src.match(/callback=CALLBACK_NAME/)) {
                        src = src.replace(/(callback=)[^&]+/, `$1${cbName}`);
                    }
                    else {
                        tag.addEventListener("load", tag.onload);
                    }
                    tag.addEventListener("error", tag.onerror);
                    switch (tagType) {
                        case "innerhtml": {
                            tag.innerHTML = src;
                            body &&
                                body.childNodes[0] &&
                                body.insertBefore(tag, body.childNodes[0]);
                            return tag;
                        }
                        case "src": {
                            tag.src = src;
                            body && body.appendChild(tag);
                            return tag;
                        }
                        case "innerhtmlhead": {
                            tag.innerHTML = src;
                            const head = document.getElementsByTagName("head")[0];
                            head &&
                                head.childNodes[0] &&
                                head.insertBefore(tag, head.childNodes[0]);
                            return tag;
                        }
                        case "innerhtmlNoScript": {
                            const noScripttag = document.createElement("noscript");
                            noScripttag.innerHTML = src;
                            body &&
                                body.childNodes[0] &&
                                body.insertBefore(noScripttag, body.childNodes[0]);
                            return noScripttag;
                        }
                        default:
                            return tag;
                    }
                });
                const initialState = {
                    loaded: false,
                    error: false,
                    promise: promise,
                    tag,
                };
                scriptMap.set(key, initialState);
            }
            return scriptMap.get(key);
        };
        Object.keys(scripts).forEach(function (key) {
            const script = scripts[key];
            Cache[key] = {
                tag: Cache._scriptTag(key, script),
                onLoad: Cache._onLoad(key),
            };
        });
        return Cache;
    };
})(window);
export default ScriptCache;

